<div style="max-width: 800px; margin-bottom: 20px;">
    <ngx-json-viewer [json]="datasource" [expanded]="false"></ngx-json-viewer>
</div>
